import React from 'react';

const PortfolioPostSlider = () => {
    return (
        <div className="infocolors-slider-wrapper stg-bottom-gap" data-appear="fade-up" data-delay="200" data-unload="fade-up">
            <div className="swiper infocolors-slider" data-autoplay="2000" data-duration="800" data-effect="slide">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <img src="img/portfolio/portfolio01/slider01.jpg" alt="Curology" width="1920" height="1080" />
                    </div>
                    <div className="swiper-slide">
                        <img src="img/portfolio/portfolio01/slider02.jpg" alt="Curology" width="1920" height="1080" />
                    </div>
                    <div className="swiper-slide">
                        <img src="img/portfolio/portfolio01/slider03.jpg" alt="Curology" width="1920" height="1080" />
                    </div>
                </div>
            </div>
            <div className="infocolors-slider-nav on-sides">
                <button className="infocolors-slider-prev">
                    <span className="infocolors-icon infocolors-icon-arrow-left"></span>
                </button>
                <button className="infocolors-slider-next">
                    <span className="infocolors-icon infocolors-icon-arrow-right"></span>
                </button>
            </div>
        </div>
    );
};

export default PortfolioPostSlider;
